import Color from '../Color.mjs'
import superMeta from '../_ARCH/metaArchNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_YELLOW,
    alias: '业务模型',
    archName: '业务地图',
    archUrl: '/ProjectBizMap',
    detailUrl: '/BaDetail',
    detailIdProp: 'baId',
    listUrl: '/BaList',
    mapProp: 'baMap',
    moduleType: 'BM',
    name: '业务结构',
    type: 'BA',
}
